import {observer} from 'mobx-react';
import {dayOfWeek} from 'shared/tools';

const Date = observer(({model}) => {
  if (!model.showDate) return null;

  return <div>{(dayOfWeek(model.date))}</div>;
});

export default Date;
